module.exports = __webpack_public_path__ + "static/media/moon.74be194c.png";